<!-- ============================================================== -->
<!-- Main wrapper - style you can find in pages.scss -->
<!-- ============================================================== -->
<div class="main-container">
  <!-- ============================================================== -->
  <!-- Topbar - style you can find in header.scss -->
  <!-- ============================================================== -->
  <div *ngIf="isMobileView">
    <mat-toolbar class="topbar relative" fxLayout="row" fxLayoutAlign="space-between center"
      style="display: flex; justify-content: space-between; align-items: center">
      <!-- Sidebar toggle button -->
      <button mat-icon-button (click)="toggleSidebar()">
        <mat-icon>{{ sidebarIcon }}</mat-icon>
      </button>

      <!-- Spacer to push the logo to the center -->
      <span fxFlex></span>

      <!-- Centered logo -->
      <div class="navbar-header" style="display: flex; justify-content: center; align-items: center">
        <a class="navbar-brand" href="index.html">
          <!-- Logo icon -->
          <b style="padding-right: 40px">
            <img src="assets/images/logo-icon.png" alt="homepage" class="dark-logo" />
            <img src="assets/logos/baguio_transparent.png" alt="homepage" class="light-logo" />
          </b>
          <!--End Logo icon -->
          <!-- Logo text -->
          <span fxShow="false" fxShow.gt-xs>
            <img src="assets/images/logo-text.png" alt="homepage" class="dark-logo" />
          </span>
        </a>
      </div>

      <!-- Spacer to push the logo to the center -->
      <span fxFlex></span>
      <!-- App header component -->
      <app-header></app-header>
    </mat-toolbar>
  </div>
  <div *ngIf="!isMobileView">
    <mat-toolbar class="topbar relative" fxLayout="row" fxLayoutAlign="space-between center">
      <!-- Spacer to push the logo to the center -->
      <span fxFlex></span>

      <!-- Centered logo -->
      <div class="navbar-header">
        <a class="navbar-brand" href="">
          <!-- Logo icon -->
          <b>
            <!--You can put here icon as well // <i class="wi wi-sunset"></i> //-->
            <!-- Dark Logo icon -->
            <img src="assets/images/logo-icon.png" alt="homepage" class="dark-logo" />
            <!-- Light Logo icon -->
            <img src="assets/logos/baguio_transparent.png" alt="homepage" class="light-logo" />
          </b>
          <!--End Logo icon -->
          <!-- Logo text -->
          <span fxShow="false" fxShow.gt-xs>
            <!-- dark Logo text -->
            <img src="assets/images/logo-text.png" alt="homepage" class="dark-logo" />
            <!-- Light Logo text -->
          </span>
        </a>
      </div>
      <!-- ============================================================== -->
      <!-- sidebar toggle -->
      <!-- ============================================================== -->
      <button mat-icon-button (click)="toggleSidebar()">
        <mat-icon>{{ sidebarIcon }}</mat-icon>
      </button>

      <!-- Spacer to push the logo to the center -->
      <span fxFlex></span>

      <!-- App header component -->
      <app-header></app-header>
    </mat-toolbar>
  </div>
  <!-- ============================================================== -->
  <!-- End Topbar - style you can find in pages.scss -->
  <!-- ============================================================== -->
  <mat-sidenav-container class="example-sidenav-container" [style.marginTop.px]="mobileQuery.matches ? 0 : 0">
    <!-- ============================================================== -->
    <!-- Sidebar - style you can find in sidebar.scss -->
    <!-- ============================================================== -->
    <mat-sidenav #snav id="snav" class="dark-sidebar pl-xs" [mode]="mobileQuery.matches ? 'side' : 'over'"
      fixedTopGap="0" [opened]="mobileQuery.matches" [disableClose]="mobileQuery.matches" (opened)="drawerOpened()"
      (closed)="drawerClosed()">
      <app-sidebar [sidenav]="snav"></app-sidebar>
    </mat-sidenav>
    <!-- ============================================================== -->
    <!-- Sidebar - style you can find in sidebar.scss -->
    <!-- ============================================================== -->

    <!-- ============================================================== -->
    <!-- Page container - style you can find in pages.scss -->
    <!-- ============================================================== -->
    <mat-sidenav-content class="page-wrapper">
      <div class="page-content">
        <router-outlet><app-spinner></app-spinner></router-outlet>
      </div>
    </mat-sidenav-content>
    <!-- ============================================================== -->
    <!-- Page container - style you can find in pages.scss -->
    <!-- ============================================================== -->
  </mat-sidenav-container>
</div>